import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import AutoForm from "react-auto-form";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

//import { ToastContainer, toast } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
    interviewPersonCategories,
    //returnTypeIdNameArrayElement
} from '../components/Enums';

export class O_Mq extends Component {

    constructor(props) {
        super(props);
        this.state = {
            missionId: props.propMissionId,
            lastOnChange: null,
            lastOnSubmit: null,
            trim: false,
            trimOnSubmit: false,
            pageLoadData: {},
            templateId: props.propTemplateId,
            countOtherDocuments: 1,
            countPerson: 1,
            //interviewPersonCategories: [
            //    { TypeId: 1, TypeName: "Beneficiary" },
            //    { TypeId: 2, TypeName: "Partner Country" },
            //    { TypeId: 3, TypeName: "Stakeholder" },
            //    { TypeId: 4, TypeName: "Other" },
            //    { TypeId: 5, TypeName: "NIPAC" },
            //    { TypeId: 6, TypeName: "EU Delegation" },
            //    { TypeId: 7, TypeName: "Contracting Authority" },
            //    { TypeId: 8, TypeName: "End Beneficiary" },
            //    { TypeId: 9, TypeName: "Lead Institution" },
            //],
        };
    }

    _onChange = (e, name, data, change) => {
        //console.log("Change: " + name + " " + data + " " + change);
        console.log("OnChange Name: " + name + " Data: " + data + " Change: " + change);

        var pageLoadDataChange = this.state.pageLoadData;
        pageLoadDataChange[name] = data;

        this.setState({
            lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });
    };

    _onSubmit = (e, data) => {
        console.log("submit");
        //console.log(data);
        this.setState({ lastOnSubmit: { data } });

        let dataToSubmit = data;
        dataToSubmit["missionId"] = this.state.missionId;
        dataToSubmit["templateId"] = this.state.templateId;
        dataToSubmit["countOtherDocuments"] = this.state.countOtherDocuments;
        dataToSubmit["countPerson"] = this.state.countPerson;
        console.log(dataToSubmit);

        this.props.propUpdatePageLoadData(dataToSubmit);

        fetch(global.variables.API_TEMPLATEFILLER_FILLANSWERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(dataToSubmit)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });

        e.preventDefault();
    };

    _onOptionsChange = (e, name, data, change) => {
        console.log(data);
        this.setState(change);
    };

    async componentDidMount() {
        await fetch(global.variables.API_TEMPLATEFILLER_GETANSWERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                operation: "GetOnGoingMq",
                missionId: this.state.missionId,
                templateId: this.state.templateId
            })
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.saveddata.length > 0) {
                    this.setState({ pageLoadData: JSON.parse(result.saveddata[0].TemplateAnswers) });

                    if (JSON.parse(result.saveddata[0].TemplateAnswers).countOtherDocuments !== undefined &&
                        JSON.parse(result.saveddata[0].TemplateAnswers).countOtherDocuments > 0) {
                        this.setState({
                            countOtherDocuments: JSON.parse(result.saveddata[0].TemplateAnswers).countOtherDocuments,
                        });
                    } else {
                        this.setState({
                            countOtherDocuments: 1,
                        });
                    }

                    if (JSON.parse(result.saveddata[0].TemplateAnswers).countPerson !== undefined &&
                        JSON.parse(result.saveddata[0].TemplateAnswers).countPerson > 0) {
                        this.setState({
                            countPerson: JSON.parse(result.saveddata[0].TemplateAnswers).countPerson,
                        });
                    } else {
                        this.setState({
                            countPerson: 1,
                        });
                    }
                }
            });

        this.props.propUpdatePageLoadData(this.state.pageLoadData);

        //console.log(this.state.pageLoadData);
        //console.log(this.state.pageLoadData.OmrQ1Context);
        //this.forceUpdate();
    }

    checkIfChecked = (element, value) => {
        //if (element === "1") {
        //    console.log("Green");
        //}

        //if (element === "2") {
        //    console.log("Orange");
        //}

        //if (element === "3") {
        //    console.log("Red");
        //}

        if (element === value) {
            //console.log("true");
            return true;
        } else {
            //console.log("false");
            return false;
        }

    };

    incrementOtherDocuments = () => {
        var countOtherDocuments = this.state.countOtherDocuments;

        if (countOtherDocuments < 20) {
            countOtherDocuments += 1;
        }

        this.setState({ countOtherDocuments: countOtherDocuments });
    }

    incrementPerson = () => {
        var countPerson = this.state.countPerson;

        if (countPerson < 20) {
            countPerson += 1;
        }

        this.setState({ countPerson: countPerson });
    }

    handleSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    handleSelectChangeUseValue = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeName });
        } else {
            await this.setState({ [vname]: "" });
        }

        console.log(this.state);
    }

    handleSelectChangePageLoadData = async (e, v, vname) => {

        //console.log("handleSelectChangePageLoadData vId: " + v.TypeId + " vName: " + v.TypeName + " vname: " + vname);

        e.persist();

        //console.log(data)
        //this.setState({ lastOnChange: { name, data, change } })

        var pageLoadDataChange = this.state.pageLoadData;
        //pageLoadDataChange[vname] = v.TypeName;
        if (v !== undefined & v !== null) {
            //pageLoadDataChange[vname] = v.TypeId;
            pageLoadDataChange[vname] = v.TypeName;
        } else {
            pageLoadDataChange[vname] = -1;
        }

        this.setState({
            //lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });

        console.log(this.state);
    }

    returnArrayElement = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeId === element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    returnArrayElementUseValue = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeName === element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    render() {
        //let { lastOnChange, lastOnSubmit, trim, trimOnSubmit } = this.state;
        let {
            trim,
            trimOnSubmit,
            pageLoadData,
            countOtherDocuments,
            countPerson,
            //interviewPersonCategories,
        } = this.state;

        //console.log("render");
        //console.log(this.state);

        //if (pageLoadData.OmqQ03Is === "1") {
        //    console.log("Green");
        //}

        //if (pageLoadData.OmqQ03Is === "2") {
        //    console.log("Orange");
        //}

        //if (pageLoadData.OmqQ03Is === "3") {
        //    console.log("Red");
        //}

        return (
            <Grid container direction="column">
                <AutoForm
                    onSubmit={this._onSubmit}
                    onChange={this._onChange}
                    trim={!!trim}
                    trimOnSubmit={!!trimOnSubmit}
                    style={{ width: "100%" }}
                >
                    <Grid item xs={12}>
                        <br />
                        <p>1. Relevance</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.1 Does the project constitute an adequate response to the current needs and rights of the target groups / end beneficiaries? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ01Does" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ01Does, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ01Does, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ01Does, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ02Does"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ02Does}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>1.2 Is the project adapted to the present institutional, human and financial capacities of the partner government and/or other key stakeholder(s) with a role in the implementation? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ03Is" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ03Is, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ03Is, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ03Is, "3")} control={<Radio />} className="red" />
                                        {
                                            //<FormControlLabel value="1" checked={() => { if (pageLoadData.OmqQ03Is === "1") { return true; } else { return false; } }} control={<Radio />} className="green" />
                                            //<FormControlLabel value="2" checked={() => { if (pageLoadData.OmqQ03Is === "2") { return true; } else { return false; } }} control={<Radio />} className="orange" />
                                            //<FormControlLabel value="3" checked={() => { if (pageLoadData.OmqQ03Is === "3") { return true; } else { return false; } }} control={<Radio />} className="red" />
                                        }
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ04Is"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ04Is}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.3 Do all the key stakeholders demonstrate effective commitment to the objectives of the project (i.e. ownership)? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ05Do" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ05Do, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ05Do, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ05Do, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ06Do"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ06Do}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.4 Is there an effective government led system of sector coordination (including Capacity Development) involving the relevant local stakeholders and donors?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ07Is">
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ07Is, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ07Is, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ07Is, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ08Is"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ08Is}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.5 Is the project likely to benefit or is benefiting from any complementarity/synergies with other projects funded by the EU and other entities (donors, public and private)? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ09Are">
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ09Are, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ09Are, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ09Are, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ10Are"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ10Are}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.6 What is the current quality of the intervention logic? Are planned outputs and outcomes coherent and feasible, and have key assumptions and risks been clearly identified? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ11Have">
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ11Have, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ11Have, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ11Have, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ12Have"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ12Have}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.7a Are the indicators well defined and relevant to measure the achievement of the objectives?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ13Are" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ13Are, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ13Are, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ13Are, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ14Are"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ14Are}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>1.7b Is the horizontal logic of the Logical Framework Matrix (LFM) adequate, i.e. choice of indicators, data availability, baseline data, target values? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ15Are" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ15Are, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ15Are, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ15Are, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ16Are"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ16Are}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.7c Are the indicators sex-disaggregated, (if relevant)? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ17Are" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ17Are, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ17Are, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ17Are, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ18Are"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ18Are}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.7d Were baselines set for each indicator? Were they updated during the project implementation? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ19Were"  >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ19Were, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ19Were, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ19Were, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ20Were"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ20Were}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.7e Are targets values set at the start of the project? If so, are they realistic or was there a need to revise / update them? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ21Are" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ21Are, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ21Are, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ21Are, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ22Are"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ22Are}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>

                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Conclusion 1 (Relevance)</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqConclusion1Relevance"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqConclusion1Relevance}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>2. Efficiency</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.1 Are the chosen implementation mechanisms (including choice of implementation modalities, entities and contractual arrangements) proving to be appropriate to achieve the planned outputs and contribute to the achievement of the outcomes? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ23Have" >
                                    <Grid item xs direction="column"  >
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ23Have, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ23Have, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ23Have, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ24Have"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ24Have}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.2 Do the partner government and other partners effectively steer the project?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ25Do" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ25Do, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ25Do, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ25Do, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ26Do"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ26Do}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.3a Are the inputs / resources provided by the various stakeholders (still) adequate for achieving the planned results? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ27Do" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ27Do, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ27Do, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ27Do, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ28Do"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ28Do}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.3b Are resources other than EU funds made available for the project?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ29To">
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ29To, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ29To, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ29To, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ30To"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ30To}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.3c To what degree are resources (inputs) from other stakeholders available on time? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ31To">
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ31To, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ31To, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ31To, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ32To"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ32To}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.4a Has the project encountered any delays? If yes, how important are they and what are the consequences on the project?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ33If" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ33If, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ33If, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ33If, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ34If"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ34If}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.4b What are the reasons for the delays and to what extent have corrective measures been implemented?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ35What" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ35What, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ35What, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ35What, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ36What"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ36What}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.4c Was the planning revised accordingly? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ37To">
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ37To, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ37To, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ37To, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ38To"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ38To}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.5 Are the outputs being produced/ delivered in a cost-efficient manner?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ39Are">
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ39Are, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ39Are, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ39Are, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ40Are"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ40Are}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.6 Does the project have an adequate internal monitoring system? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ41Is" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ41Is, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ41Is, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ41Is, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ42Is"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ42Is}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>



                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Conclusion 2 (Efficiency)</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqConclusion2Efficiency"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqConclusion2Efficiency}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>


                        <br />
                        <p>3. Effectiveness</p>






                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >3.1 Is the progress of each output conforming to plan?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ43Is" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ43Is, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ43Is, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ43Is, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ44Is"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ44Is}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >3.2 Are the outputs (including those related to Capacity Development support) being achieved with the expected quality? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ45Is" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ45Is, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ45Is, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ45Is, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ46Is"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ46Is}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >3.3 Are the expected outcomes likely to be achieved (including Capacity Development)? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ47Are">
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ47Are, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ47Are, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ47Are, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ48Are"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ48Are}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >3.4 Does the P/P effectively influence the partner’s relevant policy and actions? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ49Does" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ49Does, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ49Does, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ49Does, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ50Does"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ50Does}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>



                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Conclusion 3 (Effectiveness)</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqConclusion3Effectiveness"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqConclusion3Effectiveness}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>


                        <br />
                        <p>4. Sustainability</p>



                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >4.1 Are key stakeholders attaining the necessary capacities (including institutional, human and financial) to ensure the continued flow of benefits/services?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ51Are" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ51Are, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ51Are, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ51Are, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ52Are"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ52Are}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >4.2 Have the key stakeholders provided adequate coordination, interaction and support to the project? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ53Has">
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ53Has, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ53Has, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ53Has, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        rows={2}
                                        name="OmqQ54Has"
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ54Has}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >4.3 Is access to the benefits generated by the project affordable for target groups over the long term? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ55Is">
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ55Is, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ55Is, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ55Is, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ56Is"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ56Is}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >4.4 Have the relevant authorities taken the financial measure(s) to ensure the continuation of services after the end of the project?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ57Have" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ57Have, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ57Have, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ57Have, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        rows={2}
                                        style={{ width: "100%" }}
                                        name="OmqQ58Have"
                                        defaultValue={this.state.pageLoadData.OmqQ58Have}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>

                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >4.5 Has the private sector been sufficiently involved with a view to contributing to the sustainability of the project? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ61Has">
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ61Has, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ61Has, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ61Has, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ62Has"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ62Has}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >4.6 Have the necessary measures been taken to address environmental sustainability? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ63Have" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ63Have, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ63Have, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ63Have, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ64Have"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ64Have}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >4.7 Have the necessary measures been taken into account to enhance the role of women?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqQ65Have" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ65Have, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ65Have, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ65Have, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ66Have"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ66Have}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>




                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Conclusion 4 (Sustainability)</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqConclusion4Sustainability"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqConclusion4Sustainability}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>


                        <br />
                        <p>5. Horizontal</p>




                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >5.1 To what extent have recommendations raised in previous ROM reviews or project evaluations been taken into account?</Typography>
                            </ExpansionPanelSummary>
                            {
                                //<ExpansionPanelDetails>
                                //    <RadioGroup aria-label="gender" name="OmqQ67Have" >
                                //        <Grid item xs direction="column">
                                //            <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ67Have, "1")} control={<Radio />} className="green" />
                                //            <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ67Have, "2")} control={<Radio />} className="orange" />
                                //            <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ67Have, "3")} control={<Radio />} className="red" />
                                //        </Grid>
                                //    </RadioGroup>

                                //</ExpansionPanelDetails>
                            }
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ68Have"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ68Have}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >5.2 Is the application of the EU requirement and published guidelines on communication and visibility benefitting the EU image in the country/region? </Typography>
                            </ExpansionPanelSummary>
                            {
                                //<ExpansionPanelDetails>
                                //    <RadioGroup aria-label="gender" name="OmqQ69Have" >
                                //        <Grid item xs direction="column">
                                //            <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ69Have, "1")} control={<Radio />} className="green" />
                                //            <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ69Have, "2")} control={<Radio />} className="orange" />
                                //            <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ69Have, "3")} control={<Radio />} className="red" />
                                //        </Grid>
                                //    </RadioGroup>

                                //</ExpansionPanelDetails>
                            }
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ70Have"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ70Have}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >5.3 Are there any good practices inherent to the P/P which could be useful to share beyond the P/P context? </Typography>
                            </ExpansionPanelSummary>
                            {
                                //<ExpansionPanelDetails>
                                //    <RadioGroup aria-label="gender" name="OmqQ71Are">
                                //        <Grid item xs direction="column">
                                //            <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqQ71Are, "1")} control={<Radio />} className="green" />
                                //            <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqQ71Are, "2")} control={<Radio />} className="orange" />
                                //            <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqQ71Are, "3")} control={<Radio />} className="red" />
                                //        </Grid>
                                //    </RadioGroup>

                                //</ExpansionPanelDetails>
                            }
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmqQ72Are"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmqQ72Are}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>


                        <br />
                        <br />
                        <p><b>Sources of Information: List all documents analysed</b></p>
                        <p>Essential Project/Programme documents</p>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Country Programming documents</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqC1Country" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqC1Country, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqC1Country, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqC1Country, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Project/Action Documents</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqC2ProjectDocuments" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqC2ProjectDocuments, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqC2ProjectDocuments, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqC2ProjectDocuments, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >QSG checklists</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqC3QSG" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqC3QSG, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqC3QSG, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqC3QSG, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Financing/Contribution/Delegation/Administration Agreement or grant contract (or in some cases service contracts).</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                In these documents, all annexes are to be included such as Technical and Administrative provisions, Implementation schedule, logframe (incl. updates)
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqC4FinancingContribution" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqC4FinancingContribution, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqC4FinancingContribution, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqC4FinancingContribution, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Project contracts/programme estimates</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqC5ProjectContracts" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqC5ProjectContracts, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqC5ProjectContracts, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqC5ProjectContracts, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >In case of projects selected through calls for proposals: Guidelines for calls for proposals</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqC6InCaseOf" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqC6InCaseOf, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqC6InCaseOf, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqC6InCaseOf, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Riders to all the documents listed above and their explanatory notes</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqC7Riders" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqC7Riders, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqC7Riders, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqC7Riders, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Annual and overall activity schedules/implementation plans</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqC8Annual" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqC8Annual, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqC8Annual, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqC8Annual, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Implementation progress reports</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqC9Implementation" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqC9Implementation, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqC9Implementation, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqC9Implementation, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Previous ROM Reports</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqC10PreviousROM" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqC10PreviousROM, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqC10PreviousROM, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqC10PreviousROM, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Mid-term evaluations</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqC11MidtermEvaluation" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqC11MidtermEvaluation, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqC11MidtermEvaluation, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqC11MidtermEvaluation, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Final evaluations of previous phases (if any)</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqC12FinalEvaluations" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqC12FinalEvaluations, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqC12FinalEvaluations, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqC12FinalEvaluations, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Thematic studies and consultancy reports related to Project</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmqC13ThematicStudies" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmqC13ThematicStudies, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmqC13ThematicStudies, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmqC13ThematicStudies, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>Other Documents</p>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>Other Documents</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 0 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD1" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 0 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD1} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 1 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD2" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 1 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD2} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 2 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD3" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 2 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD3} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 3 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD4" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 3 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD4} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 4 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD5" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 4 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD5} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 5 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD6" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 5 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD6} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 6 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD7" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 6 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD7} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 7 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD8" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 7 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD8} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 8 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD9" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 8 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD9} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 9 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD10" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 9 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD10} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 10 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD11" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 10 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD11} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 11 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD12" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 11 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD12} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 12 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD13" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 12 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD13} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 13 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD14" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 13 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD14} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 14 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD15" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 14 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD15} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 15 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD16" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 15 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD16} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 16 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD17" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 16 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD17} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 17 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD18" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 17 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD18} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 18 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD19" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 18 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD19} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 19 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmqOtherDocumentsD20" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 19 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmqOtherDocumentsD20} />
                                </Grid>
                            </ExpansionPanelDetails>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.incrementOtherDocuments.bind(this)}
                                    >
                                        Add Documents
                                </Button>
                                </Grid>
                            </ExpansionPanelDetails>

                        </ExpansionPanel>


                        <br />
                        <p><b>Sources of Information: List of persons interviewed</b></p>

                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>List Of Persons Interviewed</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails style={{ display: countPerson > 0 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP1PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP1PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP1PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP1PersonName"
                                    value={pageLoadData.OmqSOIP1PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP1PersonEmail"
                                    value={pageLoadData.OmqSOIP1PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP1PersonPosition"
                                    value={pageLoadData.OmqSOIP1PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP1PersonInstitution"
                                    value={pageLoadData.OmqSOIP1PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 1 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP2PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP2PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP2PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP2PersonName"
                                    value={pageLoadData.OmqSOIP2PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP2PersonEmail"
                                    value={pageLoadData.OmqSOIP2PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP2PersonPosition"
                                    value={pageLoadData.OmqSOIP2PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP2PersonInstitution"
                                    value={pageLoadData.OmqSOIP2PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 2 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP3PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP3PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP3PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP3PersonName"
                                    value={pageLoadData.OmqSOIP3PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP3PersonEmail"
                                    value={pageLoadData.OmqSOIP3PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP3PersonPosition"
                                    value={pageLoadData.OmqSOIP3PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP3PersonInstitution"
                                    value={pageLoadData.OmqSOIP3PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 3 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP4PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP4PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP4PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP4PersonName"
                                    value={pageLoadData.OmqSOIP4PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP4PersonEmail"
                                    value={pageLoadData.OmqSOIP4PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP4PersonPosition"
                                    value={pageLoadData.OmqSOIP4PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP4PersonInstitution"
                                    value={pageLoadData.OmqSOIP4PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 4 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP5PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP5PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP5PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP5PersonName"
                                    value={pageLoadData.OmqSOIP5PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP5PersonEmail"
                                    value={pageLoadData.OmqSOIP5PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP5PersonPosition"
                                    value={pageLoadData.OmqSOIP5PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP5PersonInstitution"
                                    value={pageLoadData.OmqSOIP5PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 5 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP6PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP6PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP6PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP6PersonName"
                                    value={pageLoadData.OmqSOIP6PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP6PersonEmail"
                                    value={pageLoadData.OmqSOIP6PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP6PersonPosition"
                                    value={pageLoadData.OmqSOIP6PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP6PersonInstitution"
                                    value={pageLoadData.OmqSOIP6PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 6 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP7PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP7PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP7PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP7PersonName"
                                    value={pageLoadData.OmqSOIP7PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP7PersonEmail"
                                    value={pageLoadData.OmqSOIP7PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP7PersonPosition"
                                    value={pageLoadData.OmqSOIP7PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP7PersonInstitution"
                                    value={pageLoadData.OmqSOIP7PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 7 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP8PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP8PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP8PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP8PersonName"
                                    value={pageLoadData.OmqSOIP8PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP8PersonEmail"
                                    value={pageLoadData.OmqSOIP8PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP8PersonPosition"
                                    value={pageLoadData.OmqSOIP8PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP8PersonInstitution"
                                    value={pageLoadData.OmqSOIP8PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 8 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP9PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP9PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP9PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP9PersonName"
                                    value={pageLoadData.OmqSOIP9PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP9PersonEmail"
                                    value={pageLoadData.OmqSOIP9PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP9PersonPosition"
                                    value={pageLoadData.OmqSOIP9PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP9PersonInstitution"
                                    value={pageLoadData.OmqSOIP9PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 9 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP10PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP10PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP10PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP10PersonName"
                                    value={pageLoadData.OmqSOIP10PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP10PersonEmail"
                                    value={pageLoadData.OmqSOIP10PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP10PersonPosition"
                                    value={pageLoadData.OmqSOIP10PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP10PersonInstitution"
                                    value={pageLoadData.OmqSOIP10PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 10 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP11PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP11PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP11PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP11PersonName"
                                    value={pageLoadData.OmqSOIP11PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP11PersonEmail"
                                    value={pageLoadData.OmqSOIP11PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP11PersonPosition"
                                    value={pageLoadData.OmqSOIP11PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP11PersonInstitution"
                                    value={pageLoadData.OmqSOIP11PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 11 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP12PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP12PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP12PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP12PersonName"
                                    value={pageLoadData.OmqSOIP12PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP12PersonEmail"
                                    value={pageLoadData.OmqSOIP12PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP12PersonPosition"
                                    value={pageLoadData.OmqSOIP12PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP12PersonInstitution"
                                    value={pageLoadData.OmqSOIP12PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 12 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP13PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP13PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP13PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP13PersonName"
                                    value={pageLoadData.OmqSOIP13PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP13PersonEmail"
                                    value={pageLoadData.OmqSOIP13PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP13PersonPosition"
                                    value={pageLoadData.OmqSOIP13PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP13PersonInstitution"
                                    value={pageLoadData.OmqSOIP13PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 13 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP14PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP14PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP14PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP14PersonName"
                                    value={pageLoadData.OmqSOIP14PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP14PersonEmail"
                                    value={pageLoadData.OmqSOIP14PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP14PersonPosition"
                                    value={pageLoadData.OmqSOIP14PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP14PersonInstitution"
                                    value={pageLoadData.OmqSOIP14PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 14 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP15PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP15PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP15PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP15PersonName"
                                    value={pageLoadData.OmqSOIP15PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP15PersonEmail"
                                    value={pageLoadData.OmqSOIP15PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP15PersonPosition"
                                    value={pageLoadData.OmqSOIP15PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP15PersonInstitution"
                                    value={pageLoadData.OmqSOIP15PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 15 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP16PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP16PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP16PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP16PersonName"
                                    value={pageLoadData.OmqSOIP16PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP16PersonEmail"
                                    value={pageLoadData.OmqSOIP16PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP16PersonPosition"
                                    value={pageLoadData.OmqSOIP16PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP16PersonInstitution"
                                    value={pageLoadData.OmqSOIP16PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 16 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP17PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP17PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP17PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP17PersonName"
                                    value={pageLoadData.OmqSOIP17PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP17PersonEmail"
                                    value={pageLoadData.OmqSOIP17PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP17PersonPosition"
                                    value={pageLoadData.OmqSOIP17PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP17PersonInstitution"
                                    value={pageLoadData.OmqSOIP17PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 17 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP18PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP18PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP18PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP18PersonName"
                                    value={pageLoadData.OmqSOIP18PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP18PersonEmail"
                                    value={pageLoadData.OmqSOIP18PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP18PersonPosition"
                                    value={pageLoadData.OmqSOIP18PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP18PersonInstitution"
                                    value={pageLoadData.OmqSOIP18PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 18 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP19PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP19PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP19PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP19PersonName"
                                    value={pageLoadData.OmqSOIP19PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP19PersonEmail"
                                    value={pageLoadData.OmqSOIP19PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP19PersonPosition"
                                    value={pageLoadData.OmqSOIP19PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP19PersonInstitution"
                                    value={pageLoadData.OmqSOIP19PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 19 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmqSOIP20PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmqSOIP20PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmqSOIP20PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP20PersonName"
                                    value={pageLoadData.OmqSOIP20PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP20PersonEmail"
                                    value={pageLoadData.OmqSOIP20PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP20PersonPosition"
                                    value={pageLoadData.OmqSOIP20PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmqSOIP20PersonInstitution"
                                    value={pageLoadData.OmqSOIP20PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.incrementPerson.bind(this)}
                                    >
                                        Add Person
                                </Button>
                                </Grid>
                            </ExpansionPanelDetails>

                        </ExpansionPanel>


                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }} className="mt-1">
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                        >
                            SAVE
					    </Button>
                    </Grid>
                </AutoForm>
            </Grid>



        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/O_Mq.js